import React, { useState } from "react";
import { Col, Container, Nav, Navbar, Row } from "react-bootstrap";
import { BsArrowLeft, BsX } from "react-icons/bs";
import { Link } from "react-router-dom";

export const HomeHeader = () => (
  <Navbar bg="light" expand="lg" className="shadow-sm1">
    <Container>
      <Navbar.Brand as={Link} to="/">
        <span style={{ fontWeight: "bold" }}>
          click
          <span style={{ fontWeight: "normal" }} className="1text-muted">
            |
          </span>
          app
        </span>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-4">
          <Nav.Item>
            <Nav.Link as={Link} to="/apps">
              Apps
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to="/docs/get-started">
              Get Started
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to="/docs/tutorial">
              Tutorial
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to="/examples">
              Examples
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>
);

export const Header = () => (
  <Navbar bg="light" expand="lg" className="shadow-sm1 flex-shrink-0">
    <Container>
      <Navbar.Brand as={Link} to="/">
        <span style={{ fontWeight: "bold" }}>
          click
          <span style={{ fontWeight: "normal" }} className="1text-muted">
            |
          </span>
          app
        </span>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav>
          <Nav.Item>
            <Nav.Link as={Link} to="/apps">
              Apps
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to="/docs/get-started">
              Get Started
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to="/docs/tutorial">
              Tutorial
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to="/examples">
              Examples
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>
);

export const PreviewHeader = ({ app }) => {
  const [navbarVisible, setNavbarVisible] = useState(true);

  if (!navbarVisible) return null;

  return (
    <Navbar
      bg="white"
      expand="lg"
      className="shadow-sm1 flex-shrink-0"
      style={{ borderBottom: "3px solid #dee2e6", padding: ".1rem 1rem" }}
    >
      <Navbar.Brand
        as={Link}
        to="/apps"
        className="text-secondary"
        style={{ fontSize: "1rem" }}
      >
        <BsArrowLeft />
        <span style={{ fontWeight: "bold" }}>
          click
          <span style={{ fontWeight: "normal" }} className="1text-muted">
            |
          </span>
          app
        </span>
      </Navbar.Brand>
      <Navbar.Brand className="">
        <b>{app.label}</b>
      </Navbar.Brand>

      <Navbar.Toggle />
      <Navbar.Collapse className="justify-content-end align-items-center">
        <Link
          className="btn btn-sm btn-primary mr-2"
          to={`/apps/${app.id}/_edit`}
        >
          Edit
        </Link>
        <div style={{ paddingBottom: 3 }}>
          <a
            href="#"
            className=""
            onClick={(e) => {
              e.preventDefault();
              setNavbarVisible(false);
            }}
          >
            <BsX />
          </a>
        </div>
      </Navbar.Collapse>
    </Navbar>
  );
};
